import { Component } from '@angular/core';
import { Sidebar } from '@shared/sidebar/sidebar';
import { Navbar } from '@shared/navbar/navbar';
import { Footer } from '@shared/footer/footer';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [Sidebar, Navbar, Footer, RouterOutlet],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {}
